export const fmtUSD = (n, opts = {}) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD",
    minimumFractionDigits: opts.decimals ?? 2, maximumFractionDigits: opts.decimals ?? 2,
  }).format(v);
};

export const fmtNum = (n) => new Intl.NumberFormat("en-US").format(Number(n || 0));

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return d;
  }
};

export const ROLE_LABELS = {
  admin: "Administrator",
  finance_officer: "Finance Officer",
  staff: "Staff",
  board: "Board Member",
  auditor: "Auditor",
};
